import {history as History} from "atom";

export default container => {
    container.declare("history", dependencies => {
        // create history
        return new History(dependencies);
    });
};
